type PersonName = {
    title?: string; // we don't currently ask for this
    given?: string; // aka first name
    middle?: string;
    family?: string; // aka last name
};

export type PatientName = PersonName;

export function formatPatientName(name?: PatientName | null): string {
    return _formatPersonName(name);
}

export type UserName = PersonName;

export function formatUserName(name?: UserName | null): string {
    return _formatPersonName(name);
}

/**
 * Format a {@link PersonName} into a human-readable string.
 */
function _formatPersonName(name?: PersonName | null): string {
    if (name) {
        if (name.family && name.given && name.middle) {
            return `${name.given} ${name.middle} ${name.family}`;
        } else if (name.family && name.given) {
            return `${name.given} ${name.family}`;
        } else if (name.family) {
            return `${name.family}`;
        } else if (name.given) {
            return `${name.given}`;
        }
    }
    return '';
}
